<template>
  <base-list-item
    @onSelected="$emit('onSelected', item)"
    @toggleFavoriteState="$emit('toggleFavoriteState', item)"
    :file="item"
    :teaserUrl="teaserUrl"
    :longClickEnabled="false"
    showLocation
  >
  </base-list-item>
</template>

<script>
import common from '@/mixins/common';
import config from '@/common/config';
import BaseListItem from '@/components/listItems/BaseListItem.vue';

export default {
  name: 'NewsListItem',
  props: {
    item: Object,
  },
  mixins: [common],
  components: {
    BaseListItem,
  },
  computed: {
    teaserUrl() {
      let teaser = this.item._teasers && this.item._teasers.length > 0 ? this.item._teasers[0] : null;
      return teaser ? `${config.apiUrl}/medias/news/${teaser.filename}/${teaser.checksum}` : '';
    },
  },
};
</script>
